import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    leaderboardsContinentResponse: null,
    leaderboardsGlobalUserResponse: null,
    leaderboardsGlobalGroupResponse: null,
    monthlyWinners: null
  },
  getters: {
    LEADERBOARDS_CONTINENT_RESPONSE: state =>
      state.leaderboardsContinentResponse,
    LEADERBOARDS_GLOBAL_USER_RESPONSE: state =>
      state.leaderboardsGlobalUserResponse,
    LEADERBOARDS_GLOBAL_GROUP_RESPONSE: state =>
      state.leaderboardsGlobalGroupResponse,
    MONTHLY_WINNERS_RESPONSE: state => state.monthlyWinners
  },
  mutations: {
    SET_LEADERBOARDS_CONTINENT_RESPONSE: (state, payload) => {
      state.leaderboardsContinentResponse = payload
    },
    SET_LEADERBOARDS_GLOBAL_USER_RESPONSE: (state, payload) => {
      state.leaderboardsGlobalUserResponse = payload
    },
    SET_LEADERBOARDS_GLOBAL_GROUP_RESPONSE: (state, payload) => {
      state.leaderboardsGlobalGroupResponse = payload
    },
    SET_MONTHLY_WINNERS_RESPONSE: (state, payload) => {
      state.monthlyWinners = payload
    }
  },
  actions: {
    FETCH_LEADERBOARDS_CONTINENT: async context => {
      try {
        const response = await Axios.get('/leaderboards/continent')
        context.commit('SET_LEADERBOARDS_CONTINENT_RESPONSE', response.data)
      } catch (error) {
        context.commit(
          'SET_LEADERBOARDS_CONTINENT_RESPONSE',
          error.response.data
        )
      }
    },

    FETCH_MONTHLY_WINNERS: async context => {
      try {
        const response = await Axios.get('/leaderboards/all-continent')
        context.commit('SET_MONTHLY_WINNERS_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_MONTHLY_WINNERS_RESPONSE', error.response.data)
      }
    },

    FETCH_LEADERBOARDS_GLOBAL_USER: async context => {
      try {
        const response = await Axios.get('/leaderboards/global/user')
        context.commit('SET_LEADERBOARDS_GLOBAL_USER_RESPONSE', response.data)
      } catch (error) {
        context.commit(
          'SET_LEADERBOARDS_GLOBAL_USER_RESPONSE',
          error.response.data
        )
      }
    },

    FETCH_LEADERBOARDS_GLOBAL_GROUP: async context => {
      try {
        const response = await Axios.get('/leaderboards/global/group')
        context.commit('SET_LEADERBOARDS_GLOBAL_GROUP_RESPONSE', response.data)
      } catch (error) {
        context.commit(
          'SET_LEADERBOARDS_GLOBAL_GROUP_RESPONSE',
          error.response.data
        )
      }
    }
  }
}
